/**
 * Blocking operations that can be performed on a call.
 * ie. no two of these operations, either local or remote,
 *    can be performed at the same time.
 * TODO: Should all operations just be listed here? Probably.
 */
export const OPERATIONS = {
  // Establishment.
  MAKE: 'MAKE',
  ANSWER: 'ANSWER',
  REJECT: 'REJECT',
  IGNORE: 'IGNORE',
  END: 'END',
  SEND_RINGING_FEEDBACK: 'SEND_RINGING_FEEDBACK',
  // TODO: Make sure these constants and actionTypes are in-sync with each
  //    other. Use one to build the other.
  FORWARD_CALL: 'FORWARD_CALL',
  // Midcall.
  HOLD: 'HOLD',
  UNHOLD: 'UNHOLD',
  SEND_CUSTOM_PARAMETERS: 'SEND_CUSTOM_PARAMETERS',
  ADD_MEDIA: 'ADD_MEDIA',
  ADD_BASIC_MEDIA: 'ADD_BASIC_MEDIA',
  REMOVE_MEDIA: 'REMOVE_MEDIA',
  REMOVE_BASIC_MEDIA: 'REMOVE_BASIC_MEDIA',
  GET_STATS: 'GET_STATS',
  SEND_DTMF: 'SEND_DTMF',
  CONSULTATIVE_TRANSFER: 'CONSULTATIVE_TRANSFER',
  DIRECT_TRANSFER: 'DIRECT_TRANSFER',
  JOIN: 'JOIN',
  REPLACE_TRACK: 'REPLACE_TRACK',
  MEDIA_RESTART: 'MEDIA_RESTART',
  RESYNC: 'RESYNC',
  // Remote-only.
  START_MOH: 'START_MOH',
  STOP_MOH: 'STOP_MOH',
  SLOW_START: 'SLOW_START'
}

/*
 * Endpoints that can perform operations.
 */
export const ENDPOINTS = {
  LOCAL: 'LOCAL',
  REMOTE: 'REMOTE'
  // SERVER: 'SERVER' ?
}

/*
 * Statuses of an operation.
 */
export const OP_STATUS = {
  ONGOING: 'ONGOING', // The operation is ongoing locally.
  PENDING: 'PENDING' // The operation is pending remotely.
}

/*
 * Transitions of an operation.
 */
export const OP_TRANSITIONS = {
  START: 'START', // The operation is starting.
  UPDATE: 'UPDATE', // The operation is ongoing.
  FINISH: 'FINISH' // The operation has finished.
}

/*
 * Operations that don't have a corresponding finish operation
 */
export const NO_FINISH_OPS = [OPERATIONS.ADD_BASIC_MEDIA, OPERATIONS.REMOVE_BASIC_MEDIA]
